import { render, staticRenderFns } from "./ExportSalesNotes.vue?vue&type=template&id=496324a0&"
import script from "./ExportSalesNotes.vue?vue&type=script&lang=js&"
export * from "./ExportSalesNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports